// 摄像头组件
import React, { Component } from 'react'
// import './index.scss'

export default ({ mediaProps, styleMedia }) => {
    return (
        <div className="media-item" style={{ ...styleMedia, width: styleMedia.widthGrid }}>
            {/* <div className="tit">入口摄像头</div> */}
            <video
                id={mediaProps && `my-player${mediaProps.cameraId}`}
                className="video-js"
                controls
                width={styleMedia && styleMedia.width}
                height={styleMedia && styleMedia.height}
                preload="auto"
                muted
                autoPlay
                data-setup='{}'>
            </video>
        </div>
    )
}

